/**
 * MessageRouterGlobal - Router for the global messages screen (/messages)
 */

import React, { useEffect } from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';

import { MessageListPage, MessageDetailsPage } from './components';
import { MessageProvider } from './context';
import { setAppTitle } from 'utils/utils';

function MessageRouterGlobal(props) {
  const { path } = useRouteMatch();

  useEffect(() => {
    setAppTitle('Messages');
    return () => setAppTitle();
  }, []);

  return (
    <MessageProvider {...props} isGlobal>
      <Switch>
        <Route exact path={path} component={MessageListPage} />
        <Route path={`${path}/:message_id`} component={MessageDetailsPage} />
      </Switch>
    </MessageProvider>
  );
}

export default MessageRouterGlobal;
